/* bag-arrival.js - Trust fixes, 29 Sep 2026. The arrival estimate under Add to cart.

   The rule is the shipping policy's, and nothing else:
   - total time from order to doorstep is 5-11 business days,
   - 7-11 in the busy season, 28 Sep to 17 Jan inclusive, every year,
   - business days are Monday to Friday, and an order placed on Saturday or Sunday counts
     from Monday (the policy processes weekend orders the next business day).
   "Today" is the date in America/New_York whatever the shopper's own clock says, because
   the warehouse and the policy both run on US Eastern time.

   Worked example: an order on Tuesday 29 Sep 2026 is in season, so 7 and 11 business days
   later are Thursday 8 Oct and Wednesday 14 Oct, painted as "Arrives Oct 8-14".

   The dates are plain calendar days held in UTC, so no local timezone or daylight-saving
   switch can move a day. Liquid renders a season-correct "Arrives in 7-11 business days"
   (snippets/bag-delivery-days.liquid) for a visitor without JavaScript; this file only
   replaces that text. It also repaints [data-bag-days] (the "7-11" in the FAQ, the shipping
   strip and the home badges), because the page cache can serve yesterday's Liquid date.

   Tested in node with fixed dates: tools/test_arrival.js in the trust-fix folder. */
(function (root) {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* 28 Sep to 17 Jan inclusive, compared as month*100 + day so it wraps the new year. */
  function inSeason(month, day) {
    var md = month * 100 + day;
    return md >= 928 || md <= 117;
  }

  function daysFor(month, day) {
    return inSeason(month, day) ? [7, 11] : [5, 11];
  }

  function utcDate(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d));
  }

  /* n business days after the order date. A weekend order starts from Monday, so a
     Saturday or Sunday order lands where the following Monday's order lands. */
  function addBusinessDays(date, n) {
    var t = new Date(date.getTime());
    var dow = t.getUTCDay();
    if (dow === 6) t.setUTCDate(t.getUTCDate() + 2);
    else if (dow === 0) t.setUTCDate(t.getUTCDate() + 1);
    var added = 0;
    while (added < n) {
      t.setUTCDate(t.getUTCDate() + 1);
      var w = t.getUTCDay();
      if (w !== 0 && w !== 6) added++;
    }
    return t;
  }

  /* "Arrives Oct 8-14", or "Arrives Oct 29-Nov 4" across a month. Normal hyphen only. */
  function label(a, b) {
    var ma = MONTHS[a.getUTCMonth()];
    var mb = MONTHS[b.getUTCMonth()];
    var tail = ma === mb ? String(b.getUTCDate()) : mb + ' ' + b.getUTCDate();
    return 'Arrives ' + ma + ' ' + a.getUTCDate() + '-' + tail;
  }

  /* y, m (1-12), d: the order date in New York. */
  function estimate(y, m, d) {
    var days = daysFor(m, d);
    var start = utcDate(y, m, d);
    var first = addBusinessDays(start, days[0]);
    var last = addBusinessDays(start, days[1]);
    return { days: days, range: days[0] + '-' + days[1], first: first, last: last, text: label(first, last) };
  }

  /* Today's calendar date in New York for a given instant. */
  function newYorkDate(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now);
    var out = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'year' || parts[i].type === 'month' || parts[i].type === 'day') {
        out[parts[i].type] = parseInt(parts[i].value, 10);
      }
    }
    return { y: out.year, m: out.month, d: out.day };
  }

  function estimateAt(now) {
    var t = newYorkDate(now || new Date());
    return estimate(t.y, t.m, t.d);
  }

  /* Every write is guarded by a read, so a repaint that changes nothing writes nothing. */
  function paint(doc) {
    var d = doc || root.document;
    if (!d || !d.querySelectorAll) return;
    var e;
    try { e = estimateAt(new Date()); } catch (err) { return; } /* keep the Liquid text */
    var etas = d.querySelectorAll('[data-bag-eta]');
    for (var i = 0; i < etas.length; i++) {
      if (etas[i].textContent !== e.text) etas[i].textContent = e.text;
    }
    var spans = d.querySelectorAll('[data-bag-days]');
    for (var j = 0; j < spans.length; j++) {
      if (spans[j].textContent !== e.range) spans[j].textContent = e.range;
    }
  }

  var api = {
    inSeason: inSeason,
    daysFor: daysFor,
    addBusinessDays: addBusinessDays,
    estimate: estimate,
    estimateAt: estimateAt,
    newYorkDate: newYorkDate,
    label: label,
    paint: paint
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  /* Loaded by every block that shows a date, so it can arrive more than once on a page. */
  if (root.bagArrival) return;
  root.bagArrival = api;
  var run = function () { paint(root.document); };
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', run);
  else run();
  /* Horizon morphs the buy box on a colour change; put the date back if a morph restored
     the server text. */
  root.document.addEventListener('change', function () { root.setTimeout(run, 0); });
  root.addEventListener('pageshow', run);
})(typeof window !== 'undefined' ? window : this);
